import {Routes} from 'constants/routes';

import React, {useCallback, useEffect, useState} from 'react';

import {faGlass} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router';
import {deleteBeerACS} from 'store/beers/requestAC';
import {Beer} from 'typescript/models/Beer';
import BeerStyle from 'typescript/models/BeerStyle';
import Brewery from 'typescript/models/Brewery';

interface IProps {
  beer: Beer;
}

export const BeersTableRow = ({beer}: IProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleView = () => navigate(`${Routes.BEERS_VIEW}/${beer.id}`);

  const handleEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    navigate(`${Routes.BEERS_EDIT}/${beer.id}`);
  };

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    dispatch(deleteBeerACS({id: beer.id, name: beer.attributes.name}));
  };

  const {included} = useGlobalState((state) => state.beers);
  const [brewery, setBrewery] = useState<Brewery>();
  const [beerStyle, setBeerStyle] = useState<BeerStyle>();

  const setData = useCallback(() => {
    included?.forEach((item) => {
      if (item.type === 'breweries' && +item.id === beer.attributes.brewery_id) setBrewery(item);
      if (item.type === 'beer_styles' && +item.id === beer.attributes.beer_style_id) setBeerStyle(item);
    });
  }, [beer.attributes.brewery_id, beer.attributes.beer_style_id, included]);

  useEffect(() => {
    setData();
    // eslint-disable-next-line
  }, [setData]);

  return (
    <div className="beers-table-body__row" role="button" tabIndex={0} onClick={handleView}>
      <div className="beers-table-body__cell">
        {beer.attributes.beer_logo ? (
          <img src={beer.attributes.beer_logo!} alt="beer logo" />
        ) : (
          <span>
            <FontAwesomeIcon icon={faGlass} />
          </span>
        )}
        {beer.attributes.name}
      </div>
      <div className="beers-table-body__cell"> {brewery?.attributes.name}</div>
      <div className="beers-table-body__cell"> {beerStyle?.attributes.name} </div>
      <div className="beers-table-body__cell"> {brewery?.attributes.country} </div>
      <div className="beers-table-body__cell"> {beer.attributes.abv}% </div>
      <div className="beers-table-body__cell"> {beer.attributes.ibu} </div>
      <div className="beers-table-body__cell">
        <button onClick={(e) => handleDelete(e)}>
          <Icon icon="delete" />
        </button>
        <button onClick={handleEdit}>
          <Icon icon="edit" />
        </button>
      </div>
    </div>
  );
};
